import { jsx as _jsx } from "react/jsx-runtime";
import { isAxiosError } from 'axios';
import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import { getDetailsByRole, verifyAccessToken } from '../../api';
import { ROLES } from '@/shared/constants/roles';
import { userStore } from '@/shared/model/user';
import StorageService from '@/shared/lib/utils/storage';
import { STORAGE_KEYS } from '@/shared/constants/common';
import { extractAndSaveTokenFromCookies, extractErrorFromCookies } from '@/shared/lib/utils/cookie';
import { modalStore } from '@/shared/model/modal';
import { getUserErrorInfoByCode } from '@/shared/constants/userErrorCodes';
import { GoogleAuthErrorModal } from '@/entities/notifications/GoogleAuthErrorModal';
const useVerifyUser = () => {
    const [verifying, setVerifying] = useState(true);
    const [verified, setVerified] = useState(false);
    useEffect(() => {
        const verify = async () => {
            setVerifying(true);
            extractAndSaveTokenFromCookies();
            const errorCode = extractErrorFromCookies();
            const accessToken = StorageService.get(STORAGE_KEYS.accessToken, false);
            const verifyDetails = await verifyAccessToken();
            if (!verifyDetails || isAxiosError(verifyDetails) || !accessToken || errorCode) {
                setVerifying(false);
                setVerified(false);
                StorageService.set(STORAGE_KEYS.verified, false);
                if (errorCode) {
                    const errorInfo = getUserErrorInfoByCode(errorCode);
                    if (errorInfo) {
                        modalStore.open({
                            content: _jsx(GoogleAuthErrorModal, { title: errorInfo.title, description: errorInfo.description }),
                        });
                    }
                }
                return;
            }
            const { id, role, isAdmin } = verifyDetails.data;
            const response = await getDetailsByRole(id, role);
            if (!response || isAxiosError(response)) {
                setVerifying(false);
                setVerified(false);
                StorageService.set(STORAGE_KEYS.verified, false);
                return;
            }
            userStore.user = {
                ...response.data,
                dtBirthDate: new Date(response.data.dtBirthDate.toString().slice(0, 10)),
                role: role ?? ROLES.user,
                isAdmin: isAdmin ?? false,
            };
            StorageService.set(STORAGE_KEYS.userName, response.data.userName);
            Sentry.setUser({
                id: String(response.data.id),
                email: response.data.email,
                username: response.data.userName,
            });
            setVerifying(false);
            setVerified(true);
            StorageService.set(STORAGE_KEYS.verified, true);
        };
        verify();
    }, []);
    return [verifying, verified];
};
export default useVerifyUser;
